import {resolveBackground} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateToggleButton} from '#core/application/modules/tiles/button/index.js';

import MARKETS_GROUPS_SELECTOR from './markets-groups-selector.palette-schema.yaml';

registerTileSchema(MARKETS_GROUPS_SELECTOR);

export function generateMarketsGroupsSelector(TILE) {
    return {
        marketsMenu: {
            item: generateToggleButton(TILE.MARKETS_GROUPS_SELECTOR_BUTTON, true),
        },
        buttonBar: {
            container: {
                style: {
                    padding: 0,
                },
            },
            button: generateToggleButton(TILE.MARKETS_GROUPS_SELECTOR_BUTTON, true),
            style: {
                newFeature: {
                    ...resolveBackground(TILE.MARKETS_GROUPS_SELECTOR_BUTTON_NEW_FEATURE_LABEL_BG),
                    borderRadius: TILE.MARKETS_GROUPS_SELECTOR_BUTTON_NEW_FEATURE_LABEL_BORDER_RADIUS,
                    lineHeight: '16px',
                    bottom: '-7px',
                    right: '-4px',
                    ...TILE.MARKETS_GROUPS_SELECTOR_BUTTON_NEW_FEATURE_LABEL_TEXT,
                },
            },
            expandButtonText: {
                style: {
                    ...TILE.MARKETS_GROUPS_MORE_BUTTON_TEXT,
                },
            },
            expandButtonIcon: {
                image: {
                    style: {
                        fill: TILE.MARKETS_GROUPS_MORE_BUTTON_ICON_COLOR,
                    },
                },
            },
        },
    };
}
